export default __webpack_public_path__ + "static/media/stop-circle-solid.10430cad.svg";